import * as React from "react";
import { Link, useLocation, useNavigate } from "react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

type ReturnSource = { path: string; key: string; label: string; previous?: ReturnSource };
type ReturnState = { listEntry?: string; returnTo?: ReturnSource };

export function RelatedLink({ to, children, className, ...props }: React.ComponentProps<typeof Link>) {
  const location = useLocation();
  const state = location.state as ReturnState | null;
  const title = document.querySelector("h1")?.textContent ?? "previous page";
  return <Link {...props} to={to} className={className} state={{ returnTo: { path: location.pathname + location.search + location.hash, key: state?.listEntry ?? location.key, label: title, previous: state?.returnTo } }}>{children}</Link>;
}

export function RelatedReturn() {
  const location = useLocation();
  const navigate = useNavigate();
  const source = (location.state as ReturnState | null)?.returnTo;
  if (!source || !source.path.startsWith("/") || source.path.startsWith("//")) return null;
  return <Button variant="ghost" size="sm" onClick={() => navigate(source.path, { replace: true, state: { listEntry: source.key, returnTo: source.previous } })}><ArrowLeft className="size-3.5" /> Back to {source.label}</Button>;
}
